<div
  fxLayout="row"
  fxLayout.lt-md="column"
  fxLayoutAlign="center center"
  ngClass="w-time"
  [ngClass.xs]="'vertical-time'"
  [ngClass.sm]="'vertical-time'"
>
  <mat-toolbar
    fxLayout="column"
    fxLayout.lt-md="row"
    fxLayoutAlign="center center"
    [color]="color"
    ngClass="w-timepicker-time-container"
  >
    <div ngClass="w-timepicker-selected-time">
      <span
        [ngClass]="currentView === VIEW_HOURS ? 'active' : ''"
        (click)="setCurrentView(VIEW_HOURS)"
        >{{ formatHour() }}:</span
      >
      <span
        [ngClass]="currentView === VIEW_MINUTES ? 'active' : ''"
        (click)="setCurrentView(VIEW_MINUTES)"
        >{{ formatMinute() }}
      </span>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      ngClass="w-timepicker-selected-ampm"
      *ngIf="userTime!.format === 12"
    >
      <span
        (click)="setMeridien('AM')"
        [ngClass]="userTime!.meriden === 'AM' ? 'active' : ''"
        >AM</span
      >
      <span
        (click)="setMeridien('PM')"
        [ngClass]="userTime!.meriden === 'PM' ? 'active' : ''"
        >PM</span
      >
    </div>
  </mat-toolbar>

  <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    ngClass="w-time-content"
  >
    <pcp-clock
      [color]="color"
      ngClass="w-animation-zoom"
      [userTime]="userTime"
      (userTimeChange)="emituserTimeChange()"
      [currentView]="currentView"
      (viewChange)="setCurrentView($any($event))"
    ></pcp-clock>

    <div fxFlexAlign="end">
      <button mat-button (click)="revert.emit()">{{ revertLabel }}</button>
      <button mat-button [color]="color" (click)="done.emit(userTime!)">
        {{ submitLabel }}
      </button>
    </div>
  </div>
</div>
